import React, { useRef } from "react";
import "./Main.css";
const Main = () => {
  const scrollToAboutUs = () => {
    const projectsSection = document.getElementById("AboutUsComp");
    projectsSection.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToServices = () => {
    const techAndSkillsSection = document.getElementById("servicesComp");
    techAndSkillsSection.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div id="homedir" className="main">
      <div className="info">
        <h1 id="slogan">Less fat ' more life</h1>

        <p className="intro">
          Here fitness meets{" "}
          <span className="specialWords" onClick={scrollToServices}>
            transformation
          </span>
          , the perfect place to help you achieve your fitness goals. Join us
          for a journey to a stronger and fitter lifestyle.
        </p>
        <div className="get-started">
          <button className="explorebtn" onClick={scrollToAboutUs}>
            {" "}
            Explore
          </button>
        </div>

        <div className="mainBottom">
          <div className="mainBottomCard">
            <div className="mainBottomLogo">
              <img
                id="serviceIcon"
                src={require("../../assets/dumbell.png")}
                alt="Description"
              />
            </div>
            <div className="mainBottomHeading">Exclusive workouts</div>
            <div className="mainBottomContent">
              The workout plan that suits with your needs and ability
            </div>
          </div>
          <div className="mainBottomCard">
            <div className="mainBottomLogo">
              <img
                id="serviceIcon"
                src={require("../../assets/meal.png")}
                alt="Description"
              />
            </div>
            <div className="mainBottomHeading">Meal plans</div>
            <div className="mainBottomContent">
              The meals that help you to achieve desired outputs
            </div>
          </div>
          {/* <div className="mainBottomCard">
            <div className="mainBottomLogo">
              <img
                id="serviceIcon"
                src={require("../../assets/bar-chart.png")}
                alt="Description"
              />
            </div>
            <div className="mainBottomHeading">Fitness Plans</div>
            <div className="mainBottomContent">
              The targets and plans to get into shape
            </div>
          </div> */}
          <div className="mainBottomCard">
            <div className="mainBottomLogo">
              <img
                id="serviceIcon"
                src={require("../../assets/online-group.png")}
                alt="Description"
              />
            </div>
            <div className="mainBottomHeading">Online Community</div>
            <div className="mainBottomContent">
              Support of gym community and wellness
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
